import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { routes } from '../../index';
import RegistrationTypes from './Registration/RegistrationTypes';
import Registration from './Registration/Registration';
import TrainingRegistration from './Registration/TrainingRegistration';
import Certifications from './Certifications';
import Trainings from './Trainings';
import ExperienceHours from './Experience';
import Extensions from './Extensions';
import ExtensionRequest from './Extensions/Request';

const CertificationsAndTraining = () => (
  <Switch>
    <Route exact path={routes.certificationsAndTraining.register.root} component={RegistrationTypes} />
    <Route path={routes.certificationsAndTraining.register.training} component={TrainingRegistration} />
    <Route path={routes.certificationsAndTraining.register.type} component={Registration} />
    <Route path={routes.certificationsAndTraining.experience.root} component={ExperienceHours} />
    <Route exact path={routes.certificationsAndTraining.extension.root} component={Extensions} />
    <Route path={routes.certificationsAndTraining.extension.request} component={ExtensionRequest} />
    <Route path={routes.certificationsAndTraining.certifications.root} component={Certifications} />
    <Route exact path={routes.certificationsAndTraining.trainings.root} component={Trainings} />
  </Switch>
);

export default CertificationsAndTraining;
